import React from 'react';
import Layout from '../../components/global/layout';
import Pagination from 'react-pagination-js';
import './style.scss';
import { Link } from 'react-router-dom';
import SelectDropdown from '../../components/common/SelectDropdown';
import { Tooltip } from 'antd';
import { HiOutlineArrowDown } from 'react-icons/hi';
import { FiEdit3, FiPlus } from 'react-icons/fi';
import { BsTrash3 } from 'react-icons/bs';
import statusModel from '../../models/status.model';
import { FaEye } from 'react-icons/fa';
import moment from 'moment';
import methodModel from '../../methods/methods';
import { HiArrowSmUp } from 'react-icons/hi';

const Html = ({
  sortClass,
  sorting,
  tab,
  edit,
  reset,
  filter,
  currencys,
  view,
  tabChange,
  colClick,
  ChangeRole,
  ChangeStatus,
  openModal,
  statusChange,
  pageChange,
  addCol,
  deleteItem,
  exportCsv,
  uTableCols,
  removeCol,
  filters,
  dynamicStyle = false,
  className = null,
  tableCols,
  loaging,
  data,
  types,
  exportfun,
  total,
  dragStart,
  dragEnter,
  drop,
  dargIndex,
  dargEnterIndex,
  isAllow,
  showData,
  handleItemCountChange,
  HandleRoleFilter
}) => {
  const renderSortIcon = (columnKey) => {
    if (filters.key !== columnKey)
      return <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
    else {
      if (filters.sorder === 'asc') {
        <HiArrowSmUp className="shrink-0 inline text-sm" />;
      } else {
        <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
      }
    }
    return filters.sorder === 'asc' ? (
      <HiArrowSmUp className="shrink-0 inline text-sm" />
    ) : (
      <HiOutlineArrowDown className="shrink-0 inline text-sm" />
    );
  };

  const Role = [
    { id: 'coaches', name: 'Coaches' },
    { id: 'leagues', name: 'Leagues' },
  ];

  return (
    <Layout>
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-2xl font-semibold text-[#111827]">Plans</h3>
          <p class="text-sm font-normal text-[#525252]">
            Here you can see all about your Plan
          </p>
        </div>

        <div className="flex gap-2">

          <div className="flex justify-end items-center gap-2">
            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="All Status"
              intialValue={filters.status}
              result={(e) => {
                ChangeStatus(e.value);
              }}
              options={statusModel.list}
            />
            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="Select Role"
              intialValue={filters.role}
              result={(e) => {
                HandleRoleFilter(e.value);
              }}
              options={Role}
            />
            {/* <div className="flex justify-end items-center gap-2">
              <select
                className="relative shadow-box bg-white  rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                value={filters?.role}
                onChange={e=>HandleRoleFilter(e.target.value)}
              >
                <option value="">Select Role</option>
                <option value="leagues">Leagues</option>
                <option value="coaches">Coaches</option>
              </select>
            </div> */}

            {filters.status || filters?.role ? (
              <>
                <button
                  className="bg-primary leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2"
                  onClick={reset}
                >
                  Reset
                </button>
              </>
            ) : (
              <></>
            )}
          </div>
          {isAllow('addPlan') ? (
            <Link
              className="bg-primary leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2"
              to="/plans/add"
            >
              <FiPlus className="text-xl text-white" /> Add Plans
            </Link>
          ) : (
            <></>
          )}
        </div>
      </div>


      <div className="shadow-lg w-full bg-white rounded-lg mt-6">
        {tab == 'grid' ? (
          <></>
        ) : (
          <>
            <div className="w-full bg-white rounded-lg">
              <div className="scrollbar w-full overflow-auto">
                <table class="w-full">
                  <thead className="text-xs text-gray-700 capitalize bg-gray-50  border-b border-[#EAECF0]">
                    <tr className="border-b border-[#EAECF0]">
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                        onClick={(e) => sorting('name')}
                      >
                        Name{' '}
                        <span className="ml-2">{renderSortIcon('name')}</span>
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                        onClick={(e) => sorting('createdAt')}
                      >
                        created At{' '}
                        <span className="ml-2">
                          {renderSortIcon('createdAt')}
                        </span>
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                        onClick={(e) => sorting('createdAt')}
                      >
                        Role{' '}
                        <span className="ml-2">
                          {renderSortIcon('createdAt')}
                        </span>
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                        onClick={(e) => sorting('updatedAt')}
                      >
                        Last Modified{' '}
                        <span className="ml-2">
                          {renderSortIcon('updatedAt')}
                        </span>
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="planDrag">
                    {!loaging &&
                      data &&
                      showData().map((itm, index) => {
                        return (
                          <tr
                          // className={` ${
                          //   dargIndex == index ? 'dragStart' : ''
                          // } ${dargEnterIndex == index ? 'dragEnter' : ''}`}
                          // onDragStart={(e) => dragStart(e, index)}
                          // onDragEnter={(e) => dragEnter(e, index)}
                          // onDragEnd={(e) => drop(e)}
                          // key={index}
                          // draggable
                          >
                            <td
                              className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]"
                            >
                                <Tooltip placement="right" title="View">
                              <h4 className='user cursor-pointer'onClick={(e) => view(itm.id, 'false')}>
                              {methodModel?.capitalizeFirstLetter(itm.name)}
                              </h4>
                              </Tooltip>
                            </td>
                            <td
                              className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]"
                            >
                              {moment(itm.createdAt).format('DD MMM YYYY')}
                            </td>
                            <td
                              className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0] capitalize"
                            >
                              {(itm.role)}
                            </td>
                            <td
                              className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]"
                            >
                              {moment(itm.updatedAt).format('DD MMM YYYY')}
                            </td>
                            <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                              {' '}
                              <div
                                className={`user_hours ${itm.status}`}
                                onClick={() => statusChange(itm)}
                              >

                                <span
                                  className={`bg-[#1c2b35] text-white text-sm w-[100px] cursor-pointer !px-3 h-[30px] flex items-center justify-center border !rounded ${itm.status === 'active'
                                    ? 'bg-[#1c2b35]'
                                    : 'bg-[#A12238] '
                                    }`}
                                >
                                  {itm.status == 'deactive'
                                    ? 'Inactive'
                                    : 'Active'}
                                </span>
                              </div>
                            </td>

                            <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                              <div className="flex items-center gap-1.5">
                                {isAllow('plan_get') ? (
                                  <Tooltip placement="top" title="View">
                                    <a
                                      className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                      onClick={(e) => view(itm.id)}
                                    >
                                      <FaEye />
                                    </a>
                                  </Tooltip>
                                ) : (
                                  <></>
                                )}
                                {isAllow('editPlan') ? (
                                  <Tooltip placement="top" title="Edit">
                                    <a
                                      className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md"
                                      onClick={(e) => edit(itm.id, 'false')}
                                    >
                                      <FiEdit3 />
                                    </a>
                                  </Tooltip>
                                ) : (
                                  <></>
                                )}

                                {!itm.activeSubscription ? (
                                  <>
                                    {isAllow('deletePlan') ? (
                                      <Tooltip placement="top" title="Delete">
                                        <span
                                          className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md "
                                          onClick={() => deleteItem(itm?.id)}
                                        >
                                          <BsTrash3 />
                                        </span>
                                      </Tooltip>
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </td>
                            {/* end */}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
        {!loaging && total == 0 ? (
          <div className="py-3 text-center text-[#8b8b8b]">No Data</div>
        ) : (
          <></>
        )}
        {!loaging && total > 10 ? (
          <div className="paginationWrapper  mt-15">
             <span className='text-sm text-gray-600'>Show {filters.count} from {total} Plans</span>
            <select
              className="border-[1px] border-[#cfd5dc] rounded-[5px] px-[5px] py-[5px] bg-white text-[12px] mr-3"
              value={filters.count} // Current value of items per page
              onChange={(e) => handleItemCountChange(e)} // Function to handle changes
            >
              {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>

            <Pagination
              currentPage={filters.page}
              totalSize={total}
              sizePerPage={filters.count}
              changeCurrentPage={pageChange}
            />

          </div>
        ) : (
          <></>
        )}
        {loaging ? (
          <div className="text-center py-4">
            <img src="/assets/img/loader.gif" className="pageLoader" />
          </div>
        ) : (
          <></>
        )}
      </div>
    </Layout>
  );
};

export default Html;
